import lozad from 'lozad'
import bus from '../utils/eventBus'

const lazy = () => {
  const lazyEl = document.querySelector('.u-lazy')

  if (lazyEl) {
    const observer = lozad('.u-lazy', {
      rootMargin: '10px 0px',
      threshold: 0.1,
      loaded: function (el) {
        const imgWrapper = el.closest('.c-img')
        if (imgWrapper) {
          const placeholder = imgWrapper.querySelector('.c-img__placeholder')
          if (placeholder) {
            let bgImage = placeholder.style.backgroundImage
            bgImage = bgImage.replace('url("', '').replace('")', '')

            if (bgImage.length > 0) {
              imgWrapper.classList.add('c-img--loaded')
            }
          }
        }
        bus.emit('betasense-image-loaded', true)
      },
    })
    const observe = () => observer.observe()
    observe()

    document.addEventListener('DOMContentLoaded', () => observe, {
      once: true,
    })
  }
}

lazy()
